import { Observable } from 'rxjs';
import _ from 'lodash';

import { selectCauses } from 'entities/cause/selectors';
import { selectCampaigns } from 'entities/campaign/selectors';
import { selectSkills } from 'entities/skill/selectors';
import { selectUserLocations } from 'entities/user/selectors';
import CauseApi from 'entities/cause/api';
import CampaignApi from 'entities/campaign/api';
import SkillsApi from 'entities/skill/api';
import LocationApi from 'entities/location/api';

import { initSuccessAction, initFailedAction } from './actions';
import { INIT } from './constants';

// @TODO-VZ: This is a temporary solution to provide loading of the data for new deeds page. Need to move to hooks after refactoring.
const init = (action$, store) =>
  action$.ofType(INIT).mergeMap(() => {
    const state = store.getState();
    const actions = [];

    const causes = selectCauses(state);
    if (causes.size === 0) {
      actions.push(CauseApi.fetchAll());
    }

    const campaigns = selectCampaigns(state);
    if (campaigns.size === 0) {
      actions.push(CampaignApi.fetchAll());
    }

    const skills = selectSkills(state);
    if (skills.size === 0) {
      actions.push(SkillsApi.fetchAll());
    }

    const locations = selectUserLocations(state);
    if (locations.size === 0) {
      actions.push(LocationApi.fetchAll());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) =>
        Observable.concat(
          Observable.of(initSuccessAction()),
          Observable.of(..._.flatten(resultingActions))
        )
      )
      .catch((e) => Observable.of(initFailedAction(e)));
  });

export default [init];
